import React from "react";
import { Switch } from "react-router-dom";
import { connect } from "react-redux";
import PrivateRoute from "components/common/PrivateRoute";
import SystemList from "components/menu/master-files/system-list/system-list";

const SystemListRouter = props => (
    <div className="px-5">
        <Switch>
            <PrivateRoute
                exact
                path={`${props.match.url}/`}
                component={SystemList}
            />
        </Switch>
    </div>
);

export default connect()(SystemListRouter);
